<template>
  <span
    class="gt-flag-badge"
    :class="{ 'gt-flag-badge--empty': !text }"
    :style="badgeStyle"
    :title="title || text || undefined"
  >
    <i class="fas fa-flag" aria-hidden="true"></i>
    <span v-if="text" class="gt-flag-badge__text">{{ text }}</span>
    <!-- Acciones opcionales dentro del badge (p.ej. la × para quitar el flag). -->
    <slot></slot>
  </span>
</template>

<script>
/**
 * Bandera (flag) con el mismo aspecto en todos lados: la columna de banderas del
 * listado dinámico y la tarjeta de banderas de la operación usan este componente,
 * así el color y la forma salen de un solo lugar.
 */
import {
  normalizeFinancialCategory,
  getFinancialCategoryBadgeStyle,
} from "@/utils/financialMovementCategory";

export default {
  name: "FlagBadge",
  props: {
    /** Nombre (o id/valor de lista) del flag a mostrar. */
    name: { type: [String, Object, Array], default: "" },
    /** Catálogo de flags, para resolver el nombre y el color. */
    catalog: { type: Array, default: () => [] },
    /**
     * Texto a mostrar cuando no es el del propio `name` (p.ej. el listado muestra
     * todas las banderas en un solo badge y colorea con la primera).
     */
    label: { type: String, default: "" },
    title: { type: String, default: "" },
  },
  computed: {
    resolvedName() {
      return normalizeFinancialCategory(this.name, this.catalog);
    },
    text() {
      return this.label || this.resolvedName;
    },
    badgeStyle() {
      if (!this.text) return undefined;
      return (
        getFinancialCategoryBadgeStyle(this.resolvedName || this.text, this.catalog) ||
        undefined
      );
    },
  },
};
</script>

<style scoped>
.gt-flag-badge {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.3rem;
  min-width: 0;
  max-width: 100%;
  padding: 0.15rem 0.4rem;
  border-radius: 0.25rem;
  border: 1px solid currentColor;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
}

/* Sin bandera asignada: solo el ícono gris, sin recuadro. */
.gt-flag-badge--empty {
  padding: 0;
  border-color: transparent;
  color: #adb5bd;
}

.gt-flag-badge i {
  flex-shrink: 0;
  margin-top: 0.15rem;
}

.gt-flag-badge__text {
  white-space: normal;
  overflow: visible;
  word-break: break-word;
}
</style>
